module.exports = __webpack_public_path__ + "img/18.7550be2c.jpg";